import Cookie from 'js-cookie';

(() => {
    const allowAds = Cookie.get('WIENICOOKIE_ADS');

    if (allowAds !== 'allowed') {
        Cookie.set('LIG_OPT', 'optedout');
    } else {
        Cookie.set('LIG_OPT', 'cookie');
    }
})();


